import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ALLOWED_HOSTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { ImageMetaData } from '@sparro/app/core/models/media.model';
import { Publication } from '@sparro/app/core/models/publication.model';

import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-publication-card-image',
  templateUrl: './publication-card-image.component.html',
  styleUrls: ['./publication-card-image.component.scss']
})
export class PublicationCardImageComponent implements OnInit {
  @Input() publication: Publication;
  @Input() hasImageBadge: boolean = false;
  @Input() dialogOpenable: boolean = true;
  @Input() self: boolean = false;
  @Output() openDialogEvent = new EventEmitter();
  defaultImage = UNI_CONSTANTS.NO_IMAGE.PUBLICATION;
  @Input() showGeneralBadges: boolean = false;
  @Input() host: ALLOWED_HOSTS;

  constructor(
    private imageOptimizer: ImageOptimizerService,
  ) { }

  ngOnInit(): void {
  }

  openDialog(): boolean {
    if (this.dialogOpenable && this.publication.slug) {
      this.openDialogEvent.emit();
    }
    return !this.dialogOpenable;
  }

  getPublicationDetailLink(): string {
    if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
      return `${environment.evalUrl}/${this.publication.chamber_id}/journal/${this.publication.id}`;
    } else {
      if (this.publication.slug) {
        return `${environment.publicationUrl}${this.publication.slug}`;
      } else if (this.self) {
        return `${environment.publicationUrl}edit/${this.publication.uuid}/info`;
      }
    }
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, 420, 210);
  }
}
